<template>
  <Doughnut :data="chartdata" :options="options" />
</template>
<script>
import {Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'vue-chartjs'
ChartJS.register(ArcElement, Tooltip, Legend)
export default {
	name: "PieChart",
	components: {
		Doughnut
	},
	props: {
		chartdata: {
			type: Object,
			default: null
		},
		options: {
			type: Object,
			default: null
		}
	},
	data() {
		return {}
	},
	mounted() {
	},
	methods: {
	}
}
</script>
<style scoped></style>
